import FlutterInstallManual from "../../../../contents/docs/integrate/_snippets/install-flutter-manual.mdx";
import * as React from 'react';
export default {
  FlutterInstallManual,
  React
};